import { RouteDialogSearchParams } from "@src/core/routeDialogs/hooks/useRouteDialogPath";
import { ReactNode } from "react";
import { useSearchParams } from "react-router";

type ModalRouteProps = {
  element: ReactNode;
  path: string;
};

export function RouteDialog({ element, path }: ModalRouteProps) {
  const [searchParams] = useSearchParams();

  return searchParams.get(RouteDialogSearchParams.PATH) === path
    ? element
    : null;
}
